import router from './router'
import store from './store'
import { Message } from 'element-ui'
const whiteList = ['/login', '/auth-redirect'] // no redirect whitelist

router.beforeEach(async(to, from, next) => {
	window.document.title = to.meta.title;
	const hasToken = sessionStorage.getItem('token')
	if (hasToken) {
		if (to.path === '/login') {
			next({ path: '/' })
		} else {
			const hasRoles = store.getters.roles && store.getters.roles.length > 0
			if (hasRoles) {
				next()
			} else {
				try {      
					const { roles } = await store.dispatch('user/getInfo')
					const accessRoutes = await store.dispatch('permission/generateRoutes', roles)
				if (roles.length == 0) {
					// fix特殊情况 角色权限列表为空 导致页面一直请求用户信息接口 20.7.31  xxp
					alert('该用户权限列表为空')
					next()
				}
		
				router.addRoutes(accessRoutes)
					next({ ...to, replace: true })
				} catch (error) {
					// Message.error(error || 'Has Error')
					console.log(error || 'Has Error')
					next()
				}
			}
		}
	} else {
		if (whiteList.indexOf(to.path) !== -1) {
			next()
		} else {
			next(`/login?redirect=${to.path}`)
		}
	}
})

router.afterEach(() => {})